// Picks native <video>/<audio> sources from a project's stream, using the same
// files as the full players on the project page. HLS is skipped there too.
const HLS = 'application/x-mpegurl';

const isObject = (value) =>
  !!value && typeof value === 'object' && !Array.isArray(value);

/** Video or audio that can be played from its card: not a collection, and ready. */
export const isPlayableProject = (project) =>
  !!project &&
  (project.mediaType === 'video' || project.mediaType === 'audio') &&
  !project.collection &&
  project.state !== 'processing';

/**
 * MP4 sources, best first: the tallest rendition up to maxHeight, then the
 * rest from tallest down. Within a height, the highest bitrate first.
 */
export const getVideoSources = (stream, maxHeight = 720) => {
  if (!isObject(stream) || !isObject(stream.video)) {
    return [];
  }

  const heights = Object.keys(stream.video)
    .map(Number)
    .filter((height) => !Number.isNaN(height))
    .sort((a, b) => b - a);
  const ordered = [
    ...heights.filter((height) => height <= maxHeight),
    ...heights.filter((height) => height > maxHeight).reverse(),
  ];

  return ordered.flatMap((height) => {
    const bitrates = stream.video[height] || {};
    return Object.keys(bitrates)
      .sort((a, b) => Number(b) - Number(a))
      .flatMap((bitrate) =>
        Object.keys(bitrates[bitrate] || {})
          .filter((format) => format !== HLS)
          .map((format) => ({
            src: bitrates[bitrate][format],
            type: format === 'mp4' ? 'video/mp4' : undefined,
          }))
      );
  });
};

/** Audio sources, highest bitrate first. */
export const getAudioSources = (stream) => {
  if (!isObject(stream) || !isObject(stream.audio)) {
    return [];
  }

  return Object.keys(stream.audio)
    .sort((a, b) => Number(b) - Number(a))
    .flatMap((bitrate) =>
      Object.keys(stream.audio[bitrate] || {})
        .filter((format) => format !== HLS)
        .map((format) => ({
          src: stream.audio[bitrate][format],
          type: format === 'ogg' ? 'audio/ogg' : 'audio/mp4',
        }))
    );
};
